import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { ContainerDialog } from 'src/modules/supply_chain/components/ContainerDialog'
import { skuit } from 'src/services/skuit'

import { ContainerListTable } from 'src/components/Table/list/Container'
import { ListPage } from 'src/components/Pages/ListPage'

export const ContainerListPage = () => {
  const paginator = useQueryPaginator(
    'container-list',
    skuit.sc.containers.list
  )

  const exportFields = [
    "container_type",
    "facility_guid",
    "facility_name",
    "for_shipping",
    "guid",
    "height",
    "is_lost",
    "length",
    "name",
    "path",
    "place_guid",
    "place_name",
    "width",
  ]

  return (
    <ListPage
      title='Containers'
      paginator={paginator}
      dialogs={[{ title: 'New Container', Dialog: ContainerDialog }]}
    >
      <ContainerListTable
        paginator={paginator}
        fields={['name', 'containerType', 'facility', 'path', 'totalUnits', 'reviewNeeded']}
        bulkActions={['printContainer']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.containers.export
        }}
      />
    </ListPage>
  )
}
